import React from 'react'
import BaseModal, { BaseModalContent } from "../BaseModal";
import AddEmailModalForm from "../../Forms/profile/AddEmailModalForm";
import MailOutlineIcon from "@material-ui/icons/MailOutline";

const AddEmailModal=(props)=>{ 
    const {isOpenAddEmailModal, handleCloseAddEmailModal} = props;

    return(
        <BaseModal
            title="Add Account Email"
            align="center"
            icon={<MailOutlineIcon />}
            open={isOpenAddEmailModal}
            onClose={handleCloseAddEmailModal}
            fullWidth
            disableBackdropClick
        >
            <BaseModalContent>
                <AddEmailModalForm handleClose={handleCloseAddEmailModal}/>
            </BaseModalContent>
        </BaseModal>
    );
};

export default AddEmailModal;